import React from "react";
import Tabs from "../../components/Tabs/Tabs";
import TabPanel from "../../components/Tabs/TabPanel";

const mobileVisibleHeading = false;
const upiPayments = [
  {
    key: 0,
    heading: "Hassle-Free Agreements",
    content: (
      <div className="md:mt-[60px] pb-[12px] md:pb-0">
        <TabPanel
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          img={{
            src:
              "https://cashfreelogo.cashfree.com/website/landings/escrow-account/HassleFreeDigitalAgreements.png",
            alt: "Hassle-Free Agreements",
            width: "610",
            height: "464",
          }}
          contentClassName="!flex !justify-center !flex-col !items-baseline"
          body={
            <>
              <div className="sm:ml-[18px]">
                <div className="panel-heading text-3md md:text-shs font-semibold text-cf-hero max-w-[500px] mb-[20px] font-body text-[#240253] hidden md:block">
                  Hassle-Free Agreements
                </div>
                <p className="md:max-w-[502px]">
                  Simplify your workflow with easy agreement creation. Customise
                  on the go with our handy templates, add all the parties,
                  enable simultaneous signing, and progress through the stages
                  in a single click.
                </p>
              </div>
            </>
          }
        />
      </div>
    ),
  },
  {
    key: 1,
    heading: "Customisable Ledgers",

    content: (
      <div className="md:mt-[60px] pb-[12px] md:pb-0">
        <TabPanel
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          img={{
            src:
              "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Quickesigning.png",
            alt: "bill payments",
            width: "610",
            height: "464",
          }}
          contentClassName="!flex !justify-center !flex-col !items-baseline"
          body={
            <>
              <div className="sm:ml-[18px]">
                <div className="panel-heading text-3md md:text-shs font-semibold text-cf-hero max-w-[500px] mb-[20px] font-body text-[#240253] hidden md:block">
                  Customisable Ledgers
                </div>
                <p className="md:max-w-[502px]">
                  Boost your financial management with our customisable ledgers.
                  Create sub-accounts, easily reconcile, get real-time insights,
                  and integrate smoothly with Cashfree&apos;s plug-and-play
                  payments stack for a hassle-free experience in fund
                  management.
                </p>
              </div>
            </>
          }
        />
      </div>
    ),
  },
  {
    key: 2,
    heading: (
      <h3
        className="inline font-semibold text-[16px] body-text"
        style={{ color: "inherit" }}>
        Secure{" "}
        <h2 className="inline font-semibold text-[16px] body-text">
          Escrow Verification
        </h2>
      </h3>
    ),
    content: (
      <div className="md:mt-[60px] pb-[12px] md:pb-0">
        <TabPanel
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          img={{
            src:
              "https://cashfreelogo.cashfree.com/website/landings/escrow-account/SecureEscrowVerification.png",
            alt: "Loan Repayments",
            width: "610",
            height: "464",
          }}
          contentClassName="!flex !justify-center !flex-col !items-baseline"
          body={
            <>
              <div className="sm:ml-[18px]">
                <div className="panel-heading text-3md md:text-shs font-semibold text-cf-hero max-w-[500px] mb-[20px] font-body text-[#240253] hidden md:block">
                  Secure Escrow Verification
                </div>
                <p className="md:max-w-[502px]">
                  Keep your transactions safe with our rigorous verification
                  process including PAN and bank account checks, of all escrow
                  parties, to prevent financial fraud and ensure compliance.
                </p>
              </div>
            </>
          }
        />
      </div>
    ),
  },
  {
    key: 3,
    heading: "Unified Dashboard",
    content: (
      <div className="md:mt-[60px] pb-[12px] md:pb-0">
        <TabPanel
          headingType="div"
          mobileVisibleHeading={mobileVisibleHeading}
          img={{
            src:
              "https://cashfreelogo.cashfree.com/website/landings/escrow-account/UnifiedDashboard.png",
            alt: "Fee Payments",
            width: "610",
            height: "464",
          }}
          contentClassName="!flex !justify-center !flex-col !items-baseline"
          body={
            <>
              <div className="sm:ml-[18px]">
                <div className="panel-heading text-3md md:text-shs font-semibold text-cf-hero max-w-[500px] mb-[20px] font-body text-[#240253] hidden md:block">
                  Unified Dashboard
                </div>
                <p className="md:max-w-[470px]">
                  Never miss a detail with our transparent transaction
                  monitoring. Track all transactions, both credits and debits
                  related to an escrow agreement on a single dashboard, while
                  ensuring heightened visibility, trust, and reliability among
                  all parties.
                </p>
              </div>
            </>
          }
        />
      </div>
    ),
  },
];

const PlugAndPlay = () => {
  return (
    <section className="bg-cf-light-grey plus-n-play-bg">
      <div className="container !py-[60px]">
        <h3 className="text-[24px] md:text-[28px] md:max-w-[864px] mb-[16px]">
          Plug-and-play{" "}
          <h2 className="font-semibold text-[24px] md:text-[28px] inline">
            Escrow
          </h2>
        </h3>
        <h3 className="text-[18px] font-semibold mb-[24px]">
          Crafted by <span className="text-cf-primary">Market Leaders</span> in
          Payouts
        </h3>
        <div className=" bav-tab-panel mb-[35px]">
          <Tabs
            data={upiPayments}
            dropDown
            timerAutoPlay
            dropDownFontSize="text-base"
            customClass=""
          />
        </div>
      </div>
    </section>
  );
};
export default PlugAndPlay;
